import type { IActionGameConfig, IOutpostRunsGameConfig } from '@nova/types';

import { mergeModeGameConfig } from '../../config-utils';

import outpostRunsModeConfigJson from './outpost-runs-mode.config.json';

/** Builds the merged outpost-runs AGE game config from the shared action-game base. */
export function loadOutpostRunsGameConfig(base: IActionGameConfig): IOutpostRunsGameConfig {
  return mergeModeGameConfig<IOutpostRunsGameConfig>(base, outpostRunsModeConfigJson);
}
